import {createAsyncThunk} from '@reduxjs/toolkit';
import {ORDER_TRACKER_CONFIG} from '../../../config/orderTracker';
import {UserOrderId, OrderTrackerOrder} from '../types';
import {setAsapSelected} from '../utils/persist';

export const addUserOrderId = createAsyncThunk<
  UserOrderId,
  UserOrderId,
  {state: any}
>('orderTracker/addUserOrderId', async (userOrderId, {getState}) => {
  const state: any = getState();
  const existing = state?.orderTracker?.userOrderIds || [];

  try {
    await setAsapSelected(
      String(userOrderId.id),
      Boolean(userOrderId.isAsapSelected),
    );
  } catch {}

  const exists = existing.some((u: UserOrderId) => u.id === userOrderId.id);
  if (exists) {
    return userOrderId;
  }

  return userOrderId;
});

export const pruneExpiredOrders = createAsyncThunk<
  string[],
  void,
  {state: any}
>('orderTracker/pruneExpiredOrders', async (_, {getState}) => {
  const state: any = getState();
  const orders = state?.orderTracker?.activeOrders || [];

  const now = Date.now();
  const expired = orders.filter((order: OrderTrackerOrder) => {
    if (!order.isReady) {
      return false;
    }
    const seenAt = order.readySeenAt ?? now;
    const ageMin = (now - seenAt) / ORDER_TRACKER_CONFIG.MINUTES_IN_MS;

    return ageMin >= ORDER_TRACKER_CONFIG.READY_HIDE_TTL_MIN;
  });

  if (expired.length > 0) {
    return expired.map((order) => order.id);
  } else {
    return [];
  }
});

export const updateOrderStatus = createAsyncThunk<
  {orderId: string; status: string},
  {orderId: string; status: string},
  {state: any}
>('orderTracker/updateOrderStatus', async ({orderId, status}, {getState}) => {
  const state: any = getState();
  const orders = state?.orderTracker?.activeOrders || [];
  const order = orders.find((o: OrderTrackerOrder) => o.id === orderId);

  if (!order) {
    throw new Error(`Order ${orderId} not found`);
  }

  return {orderId, status};
});

export const removeOrder = createAsyncThunk<string, string, {state: any}>(
  'orderTracker/removeOrder',
  async (orderId, {getState}) => {
    const state: any = getState();
    const orders = state?.orderTracker?.activeOrders || [];
    const order = orders.find((o: OrderTrackerOrder) => o.id === orderId);

    if (!order) {
      throw new Error(`Order ${orderId} not found`);
    }

    return orderId;
  },
);

export const clearAllOrders = createAsyncThunk<void, void, {state: any}>(
  'orderTracker/clearAllOrders',
  async () => {
    return;
  },
);
